/* eslint-disable no-param-reassign */
import produce, { original } from 'immer';
import getInitialState from 'redux/reducers/genes/getInitialState';
var markerGenesLoaded = produce(function (draft, action) {
  var _action$payload = action.payload,
    plotUuid = _action$payload.plotUuid,
    _action$payload$data = _action$payload.data,
    orderedGeneNames = _action$payload$data.orderedGeneNames,
    rawExpression = _action$payload$data.rawExpression,
    stats = _action$payload$data.stats,
    cellOrder = _action$payload$data.cellOrder,
    _action$payload$loade = _action$payload.loadedRequestSignature,
    loadedRequestSignature = _action$payload$loade === void 0 ? null : _action$payload$loade;
  var downsampledExpressionMatrix = original(draft).expression.downsampled.matrix;
  downsampledExpressionMatrix.setGeneExpression(orderedGeneNames, rawExpression, stats);
  draft.expression.downsampled.cellOrder = cellOrder;
  draft.expression.downsampled.loadedRequestSignature = loadedRequestSignature;
  draft.expression.views[plotUuid] = {
    fetching: false,
    error: false,
    data: orderedGeneNames,
    markers: true
  };
  draft.markers.loading = false;
  draft.markers.error = false;
  draft.markers.requestSignature = null;
}, getInitialState());
export default markerGenesLoaded;